import { useEffect, useState } from 'react';
import warningIcon from '/static/svg/ic_alert_yellow.svg';
import closeIcon from '/static/svg/ic_close_banner.svg';
import { t } from 'utils/i18n';
import {
  BannerContainerStyles,
  ImgWarningStyles,
  TextBannerStyles,
  WrapperLeftWarningStyles,
} from 'layouts/dashboard/header/Header.styles';
import { useProfileService } from 'services/ProfileService';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/routeConfig';

/** 有 banner 時主內容區的 paddingTop，沿用既有值 */
const PADDING_TOP_WITH_BANNER = '160px';

const Banner = () => {
  const { infoTeacherRecruitment } = useProfileService();
  const navigate = useNavigate();

  const [
    isHiddenWarningTerminatedContract,
    setIsHiddenWarningTerminatedContract,
  ] = useState<boolean>(false);

  const [isMount, setIsMount] = useState<boolean>(false);

  useEffect(() => {
    if (infoTeacherRecruitment?.sentTerminatedContractTime) {
      if (infoTeacherRecruitment?.signedTerminatedContractTime) {
        setIsHiddenWarningTerminatedContract(false);
      } else {
        setIsHiddenWarningTerminatedContract(true);
      }
    }
  }, [infoTeacherRecruitment, isMount]);
  const handleGoToTerminatedContract = () => {
    navigate(PATH.TEACHER_TERMINATED_CONTRACT, { replace: true });
  };

  /**
   * Header 是 fixed，主內容區靠 paddingTop 避開它；多出 banner 時要再往下讓一段。
   *
   * 沒有 banner 時清掉 inline style（而非寫死 116px），讓 MainStyle 自己的響應式
   * paddingTop 生效 —— 桌機 116px、手機 88px。
   */
  useEffect(() => {
    const mainLayout = document.body.querySelector(
      '.showHiddenWarningBanner',
    ) as HTMLElement;
    if (!mainLayout) return;

    mainLayout.style.paddingTop = isHiddenWarningTerminatedContract
      ? PADDING_TOP_WITH_BANNER
      : '';
  }, [isHiddenWarningTerminatedContract]);

  const handleCloseWaringTerminatedContract = () => {
    setIsHiddenWarningTerminatedContract(false);
  };

  useEffect(() => {
    setIsMount(true);
  }, []);

  if (!isHiddenWarningTerminatedContract) return null;

  return (
    <BannerContainerStyles>
      <WrapperLeftWarningStyles onClick={handleGoToTerminatedContract}>
        <ImgWarningStyles src={warningIcon} />
        <TextBannerStyles>
          {t(
            'layouts.dashboard.header.banner.warningTerminatedContract',
            '您收到授課講師終止合約協議書，請盡快簽署',
          )}
        </TextBannerStyles>
      </WrapperLeftWarningStyles>

      <ImgWarningStyles
        src={closeIcon}
        onClick={handleCloseWaringTerminatedContract}
      />
    </BannerContainerStyles>
  );
};

export default Banner;
